export const translations = {
  ar: {
    // Brand
    brandTagline: 'منصة وكلاء الواتساب الذكيين للشركات',
    // Nav
    home: 'الرئيسية',
    dashboard: 'لوحة التحكم',
    create: 'إنشاء بوت',
    admin: 'لوحة الإدارة',
    garden: 'حديقة الأدمن',
    loginGoogle: 'الدخول بـ Google',
    logout: 'خروج',
    trialCta: 'تجربة Pro مجانية 7 أيام',
    contactSales: 'تواصل عبر واتساب',
    // Common
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    start: 'تشغيل',
    stop: 'إيقاف',
    connect: 'ربط',
    disconnect: 'فصل',
    loading: 'جارٍ التحميل...',
    status: 'الحالة',
    actions: 'إجراءات',
    plan: 'الباقة',
    role: 'الصلاحية',
    daily: 'اليومي',
    // Status
    s_connected: 'متصل',
    s_connecting: 'جارٍ الاتصال',
    s_qr_ready: 'بانتظار المسح',
    s_disconnected: 'غير متصل',
    s_logged_out: 'تم تسجيل الخروج',
    // Modes
    modeFixed: 'الرد التلقائي العام (Automatic Response Message)',
    modeQa: 'مطابقة أسئلة (FAQ)',
    modeAi: 'الرد الذكي بالذكاء الاصطناعي (AI Agent)',
    modeFixedDesc: 'رسالة تلقائية ثابتة بيترد بيها على أي حد يكلمنا بشكل عام.',
    modeQaDesc: 'Gemini يختار أقرب إجابة من قائمتك.',
    modeAiDesc: 'بوت متكامل مخصص بشخصية شركتك.',
    // AI Blocklist
    aiBlocklistTab: 'حظر الرد بالذكاء الاصطناعي (AI Blocklist)',
    aiBlocklistDesc: 'أدخل أرقام الهواتف المراد منع الرد عليها بالذكاء الاصطناعي (مفيد لاستثناء الموظفين أو الحسابات الشخصية).',
    addBlockPhone: 'إضافة رقم للحظر',
    phonePlaceholder: 'مثال: 201001234567',
    noBlockedPhones: 'لا يوجد أرقام محظورة حالياً.',
    // Wizard
    wizardNameLabel: 'اسم البوت',
    wizardModeLabel: 'نوع الرد',
    wizardFixedLabel: 'نص الرسالة التلقائية العامة',
    wizardQaLabel: 'الأسئلة والأجوبة',
    question: 'سؤال',
    answer: 'إجابة',
    addQa: 'إضافة سؤال',
    personaLabel: 'الشخصية (Persona)',
    instructionsLabel: 'تعليمات الشركة',
    servicesLabel: 'الخدمات والأسعار',
    routePhoneLabel: 'رقم تحويل الشراء',
    saveAndStart: 'حفظ وعرض QR',
    // Dashboard
    instancesTitle: 'وكلاؤك',
    instancesSubtitle: 'إدارة ومتابعة بوتاتك واستهلاكك اليومي',
    newInstance: 'بوت جديد',
    noInstances: 'لا توجد بوتات بعد',
    noInstancesBody: 'أنشئ أول بوت واتساب وابدأ الرد الآلي على عملائك.',
    quotaLabel: 'استهلاك اليوم',
    instancesUsed: 'البوتات النشطة',
    // QR
    qrTitle: 'امسح رمز QR',
    qrHelp: 'افتح واتساب ← الإعدادات ← الأجهزة المرتبطة ← اربط جهاز.',
    qrConnected: 'تم الربط بنجاح!',
    qrGenerating: 'جارٍ توليد الرمز...',
    // Plans
    planFree: 'المجانية',
    planPro: 'Pro',
    planUltra: 'Ultra',
    freeDesc: 'للتجربة والبدايات',
    proDesc: 'للشركات النامية',
    ultraDesc: 'للشركات الكثيفة',
    perMonth: '/شهرياً',
    choose: 'اختر',
    current: 'باقتك الحالية',
    upgrade: 'ترقية',
    // Landing
    heroTitle: 'بوت واتساب ذكي يعمل 24/7 [بشخصية شركتك]',
    heroSubtitle: 'اربط أرقام واتساب، خصّص شخصية وخدمات البوت، ودع الذكاء الاصطناعي يرد على عملائك تلقائياً.',
    heroCta: 'ابدأ مجاناً الآن',
    heroTrialNote: 'بدون بطاقة ائتمان · تجربة Pro كاملة 7 أيام',
    feat1Title: '10 مفاتيح Gemini',
    feat1Body: 'توزيع أحمال تلقائي لاستمرار الرد دون انقطاع.',
    feat2Title: '3 أنماط رد',
    feat2Body: 'رد تلقائي عام ثابت، مطابقة أسئلة، أو وكيل ذكي مخصص.',
    feat3Title: 'PWA على الجوال',
    feat3Body: 'ثبّت التطبيق على iOS و Android بأيقونة واضحة.',
    feat4Title: 'تخويل آمن',
    feat4Body: 'Google Sign-In + صلاحيات مخصصة لكل مستخدم.',
    // Admin
    adminTitle: 'لوحة الإدارة',
    adminSubtitle: 'المستخدمون والاشتراكات وموازن الأحمال',
    users: 'المستخدمون',
    totalUsers: 'إجمالي المستخدمين',
    totalInstances: 'البوتات النشطة',
    geminiPool: 'موازن مفاتيح Gemini',
    geminiModel: 'الموديل النشط',
    geminiKeys: 'المفاتيح',
    cursor: 'المؤشر',
    refresh: 'تحديث',
    saveGemini: 'تطبيق',
    gardenTitle: 'حديقة الأدمن',
    gardenSubtitle: 'بوتات داخلية لشركة OLTANI للدعم والحجز',
    newGardenBot: 'إضافة بوت',
    // Errors
    errAuth: 'يجب تسجيل الدخول أولاً.',
    errAdmin: 'صلاحيات الأدمن مطلوبة.',
    errPlanLimit: 'وصلت للحد الأقصى لبوتاتك. رقّ باقتك.'
  },
  en: {
    brandTagline: 'AI WhatsApp agents platform for businesses',
    home: 'Home',
    dashboard: 'Dashboard',
    create: 'New Agent',
    admin: 'Admin',
    garden: 'Admin Garden',
    loginGoogle: 'Sign in with Google',
    logout: 'Logout',
    trialCta: '7-day Pro free trial',
    contactSales: 'Contact sales',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    start: 'Start',
    stop: 'Stop',
    connect: 'Connect',
    disconnect: 'Disconnect',
    loading: 'Loading...',
    status: 'Status',
    actions: 'Actions',
    plan: 'Plan',
    role: 'Role',
    daily: 'Daily',
    s_connected: 'Connected',
    s_connecting: 'Connecting',
    s_qr_ready: 'Awaiting scan',
    s_disconnected: 'Disconnected',
    s_logged_out: 'Logged out',
    modeFixed: 'Automatic Response Message',
    modeQa: 'QA matcher',
    modeAi: 'Smart AI Agent',
    modeFixedDesc: 'One automatic general response message to anyone messaging.',
    modeQaDesc: 'Gemini picks the closest answer from your list.',
    modeAiDesc: 'A fully custom bot with your brand persona.',
    aiBlocklistTab: 'AI Phone Blocklist',
    aiBlocklistDesc: 'Excludes specific phone numbers from getting AI responses (useful for staff or personal numbers).',
    addBlockPhone: 'Add Phone to Blocklist',
    phonePlaceholder: 'e.g. 201001234567',
    noBlockedPhones: 'No phone numbers blocked yet.',
    wizardNameLabel: 'Agent name',
    wizardModeLabel: 'Reply mode',
    wizardFixedLabel: 'Automatic Response Message text',
    wizardQaLabel: 'Questions & Answers',
    question: 'Question',
    answer: 'Answer',
    addQa: 'Add QA',
    personaLabel: 'Persona',
    instructionsLabel: 'Company instructions',
    servicesLabel: 'Services & pricing',
    routePhoneLabel: 'Routing phone (purchase)',
    saveAndStart: 'Save & show QR',
    instancesTitle: 'Your agents',
    instancesSubtitle: 'Manage your bots and daily usage',
    newInstance: 'New agent',
    noInstances: 'No agents yet',
    noInstancesBody: 'Create your first WhatsApp bot and start automating replies.',
    quotaLabel: 'Today usage',
    instancesUsed: 'Active agents',
    qrTitle: 'Scan the QR',
    qrHelp: 'Open WhatsApp → Settings → Linked devices → Link a device.',
    qrConnected: 'Connected successfully!',
    qrGenerating: 'Generating QR...',
    planFree: 'Free',
    planPro: 'Pro',
    planUltra: 'Ultra',
    freeDesc: 'For trying things out',
    proDesc: 'For growing teams',
    ultraDesc: 'For heavy usage',
    perMonth: '/mo',
    choose: 'Choose',
    current: 'Current plan',
    upgrade: 'Upgrade',
    heroTitle: 'A smart WhatsApp agent working 24/7 [with your brand voice]',
    heroSubtitle: 'Link WhatsApp numbers, customize your bot persona and services, and let AI reply to customers automatically.',
    heroCta: 'Start free',
    heroTrialNote: 'No card required · full Pro for 7 days',
    feat1Title: '10 Gemini keys',
    feat1Body: 'Automatic load balancing keeps replies flowing.',
    feat2Title: '3 reply modes',
    feat2Body: 'Automatic general response, QA matcher, or a fully custom agent.',
    feat3Title: 'Mobile PWA',
    feat3Body: 'Install on iOS and Android with a clean icon.',
    feat4Title: 'Secure auth',
    feat4Body: 'Google Sign-In + per-user custom claims.',
    adminTitle: 'Admin Panel',
    adminSubtitle: 'Users, subscriptions and load balancer',
    users: 'Users',
    totalUsers: 'Total users',
    totalInstances: 'Active agents',
    geminiPool: 'Gemini keys pool',
    geminiModel: 'Active model',
    geminiKeys: 'Keys',
    cursor: 'Cursor',
    refresh: 'Refresh',
    saveGemini: 'Apply',
    gardenTitle: 'Admin Garden',
    gardenSubtitle: 'Internal OLTANI bots for support & bookings',
    newGardenBot: 'Add bot',
    errAuth: 'Please sign in first.',
    errAdmin: 'Admin privileges required.',
    errPlanLimit: 'You reached your agent limit. Upgrade your plan.'
  }
};
